import { useEffect, useRef, useState } from 'react';

const useHeaderScroll = () => {
    const [navVisible, setNavVisible] = useState(true);

    const lastScrollY = useRef(0);
    const scrollAccumulator = useRef(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const delta = currentScrollY - lastScrollY.current;

            // Reset accumulator on direction change
            if (delta * scrollAccumulator.current < 0) {
                scrollAccumulator.current = 0;
            }

            scrollAccumulator.current += delta;

            const isNearTop = currentScrollY < 150;

            const shouldShow = isNearTop || scrollAccumulator.current < -50;

            const shouldHide = scrollAccumulator.current > 50 && !isNearTop;

            if (shouldHide && navVisible) {
                setNavVisible(false);
                scrollAccumulator.current = 0;
            } else if (shouldShow && !navVisible) {
                setNavVisible(true);
                scrollAccumulator.current = 0;
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [navVisible]);

    return navVisible;
};

export default useHeaderScroll;
